export default __webpack_public_path__ + "static/media/math-wallet.06a89b6c.svg";